"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createApiMachineRepo = createApiMachineRepo;
const HTTPClient_1 = require("../../../common/api/HTTPClient");
const http_helpers_1 = require("../../../common/api/http-helpers");
const Machine_1 = require("../domain/Machine");
const ItemList_1 = require("../../../common/models/ItemList");
const AisleMapper_1 = require("./mappers/AisleMapper");
const MachineMapper_1 = require("./mappers/MachineMapper");
const getApiUrl_1 = require("../../../common/api/utils/getApiUrl");
const buildApiUrl_1 = require("../../../common/api/utils/buildApiUrl");
const parseApiError_1 = require("../../../common/api/utils/parseApiError");
/**
 * Notifica el error y lo relanza como `ApiError`, conservando el
 * `title`/`detail` del backend para que la UI pueda traducirlo.
 */
function handleAndRethrow(error) {
    const apiError = (0, parseApiError_1.parseApiError)(error);
    (0, http_helpers_1.handleError)(apiError);
    throw apiError;
}
function createApiMachineRepo() {
    return {
        getAll,
        getProductsByMachine,
        getBasicInfo,
        getAisleBalance,
        getAisleWeight,
        getBalance,
        updateAisleWeight,
        resetAisleWeight,
        openMachineDoor,
        restartMachine,
        updatePriceOrProduct,
        updateMachineCapacity,
        updateStock,
        updateStocks,
        getMachineConfig,
        updateMachineConfig,
    };
}
async function getAll(page = 1, pageSize = 10, clubName = '', filter = '', isOnline = '') {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, buildApiUrl_1.buildApiUrl)('/v1/machines', {
                page,
                pageSize,
                clubName,
                filter,
                isOnline,
            }),
        });
        const machineList = {
            items: res.machines.map(MachineMapper_1.mapToDomainMachine),
            pagination: res.pagination,
        };
        (0, http_helpers_1.sendSuccessStatus)();
        return machineList;
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return (0, ItemList_1.emptyList)();
    }
}
async function getProductsByMachine(id) {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/machines/${id}`),
        });
        const aisleList = res.aisles.map((aisleDto) => (0, AisleMapper_1.mapToDomainAisle)(aisleDto));
        const machine = (0, MachineMapper_1.mapToDomainMachine)(res.machine);
        (0, http_helpers_1.sendSuccessStatus)();
        return {
            machine,
            aisles: aisleList,
        };
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return {
            machine: (0, Machine_1.emptyMachine)(),
            aisles: [],
        };
    }
}
async function getBasicInfo() {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/machines/basic-info`),
        });
        (0, http_helpers_1.sendSuccessStatus)();
        return res;
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return [];
    }
}
async function openMachineDoor(id) {
    try {
        await HTTPClient_1.HTTPClient.post({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/machines/${id}/door/open`),
        });
        (0, http_helpers_1.sendSuccessStatus)();
    }
    catch (error) {
        handleAndRethrow(error);
    }
}
async function restartMachine(id) {
    try {
        await HTTPClient_1.HTTPClient.post({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/machines/${id}/restart`),
        });
        (0, http_helpers_1.sendSuccessStatus)();
    }
    catch (error) {
        handleAndRethrow(error);
    }
}
async function updatePriceOrProduct(machineId, aisleCode, micronProductId, price) {
    try {
        await HTTPClient_1.HTTPClient.put({
            url: (0, getApiUrl_1.getApiUrl)(`v1/machines/${machineId}/aisle`),
            body: {
                aisleCode,
                micronProductId,
                price,
            },
            type: 'json',
        });
        (0, http_helpers_1.sendSuccessStatus)();
    }
    catch (error) {
        handleAndRethrow(error);
    }
}
async function updateMachineCapacity(machineId, micronAisleId, aisleCode, capacity) {
    try {
        await HTTPClient_1.HTTPClient.put({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/machines/${machineId}/aisle/capacity`),
            body: {
                micronAisleId,
                aisleCode,
                capacity,
            },
            type: 'json',
        });
        (0, http_helpers_1.sendSuccessStatus)();
    }
    catch (error) {
        handleAndRethrow(error);
    }
}
async function updateStock(machineId, micronAisleId, aisleCode, currStock) {
    console.log(machineId, micronAisleId, aisleCode, currStock);
    try {
        await HTTPClient_1.HTTPClient.put({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/machines/${machineId}/aisle/stock`),
            body: {
                micronAisleId,
                aisleCode,
                currStock,
            },
            type: 'json',
        });
        (0, http_helpers_1.sendSuccessStatus)();
    }
    catch (error) {
        handleAndRethrow(error);
    }
}
async function updateStocks(machineId, reFills) {
    try {
        await HTTPClient_1.HTTPClient.put({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/machines/${machineId}/aisles/stock`),
            body: reFills,
            type: 'json',
        });
        (0, http_helpers_1.sendSuccessStatus)();
    }
    catch (error) {
        handleAndRethrow(error);
    }
}
async function getAisleBalance(aisleCode, machineId) {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/machines/${machineId}/aisle/${aisleCode}/balance`),
        });
        (0, http_helpers_1.sendSuccessStatus)();
        return res;
    }
    catch (error) {
        handleAndRethrow(error);
    }
}
async function getBalance(machineId) {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/machines/${machineId}/balance`),
        });
        (0, http_helpers_1.sendSuccessStatus)();
        return res;
    }
    catch (error) {
        handleAndRethrow(error);
    }
}
async function getAisleWeight(machineId, aisleCode) {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/machines/${machineId}/aisle/${aisleCode}/weight`),
        });
        (0, http_helpers_1.sendSuccessStatus)();
        return res;
    }
    catch (error) {
        handleAndRethrow(error);
    }
}
async function updateAisleWeight(machineId, aisleCode, newWeight) {
    try {
        await HTTPClient_1.HTTPClient.put({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/machines/${machineId}/aisle/${aisleCode}/weight`),
            body: { newWeight },
            type: 'json',
        });
        (0, http_helpers_1.sendSuccessStatus)();
    }
    catch (error) {
        handleAndRethrow(error);
    }
}
async function resetAisleWeight(machineId, aisleCode) {
    try {
        await HTTPClient_1.HTTPClient.put({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/machines/${machineId}/aisle/${aisleCode}/weight/reset`),
        });
        (0, http_helpers_1.sendSuccessStatus)();
    }
    catch (error) {
        handleAndRethrow(error);
    }
}
async function getMachineConfig(machineId) {
    try {
        const res = await HTTPClient_1.HTTPClient.get({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/machines/${machineId}/configuration`),
        });
        /*const res = await HTTPClient.get<MachineConfig>({
          url: getApiUrl(
            `https://mkz0g.wiremockapi.cloud/v1/v1/machines/${machineId}/configuration`
          ),
        })*/
        (0, http_helpers_1.sendSuccessStatus)();
        return (0, Machine_1.normalizeMachineConfig)(res);
    }
    catch (error) {
        (0, http_helpers_1.handleError)(error);
        return (0, Machine_1.emptyMachineConfig)();
    }
}
async function updateMachineConfig(machineId, config) {
    try {
        const res = await HTTPClient_1.HTTPClient.put({
            url: (0, getApiUrl_1.getApiUrl)(`/v1/machines/${machineId}/configuration`),
            body: config,
            type: 'json',
        });
        /*const res = await HTTPClient.put<MachineConfig>({
          url: `https://mkz0g.wiremockapi.cloud/v1/v1/machines/${machineId}/configuration`,
          body: config,
          type: 'json',
        })*/
        (0, http_helpers_1.sendSuccessStatus)();
        return (0, Machine_1.normalizeMachineConfig)(res);
    }
    catch (error) {
        handleAndRethrow(error);
    }
}
